import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import Hero from '../components/hero';
import ThemesGrid from '../components/themes-grid';

import config from '../utils/config';

const indexPage = css``;

const IndexPage = ({ data }) => {
  const { heroImage, featuredThemes } = data;

  return (
    <div className={indexPage}>
      <Helmet>
        <title>{'Lovingly Crafted Tumblr Themes'}</title>
        <meta name="description" content={config.siteDescription} />
      </Helmet>
      <Hero image={heroImage} plug={'Lovingly crafted Tumblr themes for bloggers and creatives.'} />
      <ThemesGrid
        themes={featuredThemes.edges}
        title={'Featured Tumblr themes.'}
        teaser={true}
        teaserLink={'/tumblr-themes/'}
      />
    </div>
  );
};

IndexPage.propTypes = {
  data: PropTypes.object,
};

export default IndexPage;

export const query = graphql`
  query indexQuery {
    heroImage: file(
      sourceInstanceName: { eq: "images" }
      relativePath: { eq: "portfolio-comp.jpg" }
    ) {
      ...heroImage
    }

    featuredThemes: allMarkdownRemark(
      filter: { fields: { instanceName: { eq: "theme" } }, frontmatter: { featured: { eq: true } } }
      sort: { fields: [fields___created], order: DESC }
    ) {
      edges {
        node {
          ...themePreview_details
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js